import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=0a4b77aa&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=0a4b77aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b77aa",
  null
  
)

component.options.__file = "Home.vue"
export default component.exports